import { useRef, useState } from 'react';
import PassoFicha, {
  type PassoFichaHandle,
} from '@/pages/assistente-evento/components/PassoFicha';
import { mensagemAmigavel } from '@/lib/mensagemAmigavel';
import type { FormaParticipar } from '@/pages/assistente-evento/types';

interface Props {
  participacoes: FormaParticipar[];
  onChange: (p: FormaParticipar[]) => void;
  aoFechar: () => void;
  aoSalvo: () => void;
}

export default function FichaEditor({ participacoes, onChange, aoFechar, aoSalvo }: Props) {
  const ref = useRef<PassoFichaHandle>(null);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function salvar() {
    if (!ref.current) return;
    setSalvando(true);
    setErro(null);
    try {
      const ok = await ref.current.validar();
      if (!ok) return;
      aoSalvo();
      aoFechar();
    } catch (e) {
      setErro(mensagemAmigavel(e));
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div className="space-y-5">
      {erro && (
        <p className="rounded-md border border-danger-200 bg-danger-50 px-3 py-2 text-sm text-danger-700">
          {erro}
        </p>
      )}

      <PassoFicha ref={ref} participacoes={participacoes} onChange={onChange} />

      <div className="sticky bottom-0 -mx-5 flex gap-2 border-t border-secondary-100 bg-white px-5 py-3">
        <button
          type="button"
          onClick={salvar}
          disabled={salvando}
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {salvando ? 'Salvando…' : 'Salvar'}
        </button>
        <button
          type="button"
          onClick={aoFechar}
          disabled={salvando}
          className="cursor-pointer whitespace-nowrap rounded-md px-4 py-2.5 text-sm font-medium text-secondary-600 transition-colors hover:bg-background-100 disabled:opacity-50"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}